const RegisterState={
    REGISTERED: 'Registered',
    UNREGISTERED: 'Unregistered'
}

const onStart = async(registerer, userAgent, agentRegistered,agentUnRegistered)=>{
    try{

        registerer.stateChange.addListener((newState) => {
            
            if (newState === RegisterState.REGISTERED) {
              agentRegistered();
            } else if (newState === RegisterState.UNREGISTERED) {
              agentUnRegistered();
            }
          });

        userAgent.start().then(()=> {
            registerer.register() 
        })
        .catch(error=> console.log('Error registering', error))     
    }catch (error) {
        console.log('Error starting agent', error);
    }
}

const onDisconnectAgent = async(registerer, agentUnRegistered)=>{
    try{
        registerer.unregister().then(()=>{
            agentUnRegistered();
        })  
    }catch (error) {
        console.log('Error to unregister', error);
    }
}

export {onStart, onDisconnectAgent};